import { useState } from "react";

const ICT_TOGGLES = [
  { key: "fvg",      label: "FVG zones",            color: "amber"   },
  { key: "ifvg",     label: "Inverse FVG (IFVG)",   color: "orange"  },
  { key: "swings",   label: "Swing Highs / Lows",   color: "slate"   },
  { key: "structure",label: "BOS / MSS markers",    color: "fuchsia" },
  { key: "sweeps",   label: "Liquidity Sweeps",     color: "sky"     },
  { key: "smt",      label: "SMT Divergence",       color: "pink"    },
  { key: "pd",       label: "Premium / Discount",   color: "purple"  },
  { key: "sessions", label: "Liquidity Sessions",   color: "blue"    },
];

const SOUND_TOGGLES = [
  { key: "FVG",       label: "FVG sound" },
  { key: "IFVG",      label: "IFVG sound" },
  { key: "BOS",       label: "BOS sound" },
  { key: "MSS",       label: "MSS sound" },
  { key: "SWEEP_BSL", label: "Sweep BSL sound" },
  { key: "SWEEP_SSL", label: "Sweep SSL sound" },
  { key: "SMT",       label: "SMT divergence sound" },
  { key: "SESSION",   label: "Session open sound" },
  { key: "PREMIUM",   label: "Premium tone" },
  { key: "DISCOUNT",  label: "Discount tone" },
];

export default function SettingsPanel({ visualToggles, setVisualToggles, soundOn, setSoundOn, soundToggles, setSoundToggles, hidden = false }) {
  const [open, setOpen] = useState(false);
  const update = (k, v) => setVisualToggles({ ...visualToggles, [k]: v });
  const updateSound = (k, v) => setSoundToggles({ ...soundToggles, [k]: v });

  if (hidden) return null;

  return (
    <div className="border-t border-slate-800">
      <button data-testid="settings-toggle" onClick={() => setOpen(o => !o)}
        className="w-full px-4 py-2 flex justify-between items-center text-[11px] uppercase tracking-wider text-slate-400 font-bold hover:bg-slate-900/40">
        <span><i className="fa-solid fa-sliders text-blue-400 mr-1.5"/> ICT Display & Sound Settings</span>
        <i className={`fa-solid fa-chevron-${open ? "up" : "down"} text-[10px]`}/>
      </button>
      {open && (
        <div className="px-4 pb-3 space-y-3 text-[11px] max-h-72 overflow-y-auto" data-testid="settings-panel">
          <div>
            <div className="text-slate-500 font-bold uppercase tracking-wider text-[10px] mb-1.5">Chart Overlays</div>
            <div className="grid grid-cols-1 gap-1.5">
              {ICT_TOGGLES.map(t => (
                <Toggle key={t.key} testid={`toggle-${t.key}`} label={t.label}
                        checked={visualToggles[t.key]} onChange={(v) => update(t.key, v)} />
              ))}
            </div>
          </div>
          <div className="pt-2 border-t border-slate-800/80">
            <div className="flex justify-between items-center mb-1.5">
              <div className="text-slate-500 font-bold uppercase tracking-wider text-[10px]">Sound Master</div>
              <Toggle testid="toggle-sound-master" label="" checked={soundOn} onChange={setSoundOn} />
            </div>
            <div className="grid grid-cols-1 gap-1 opacity-90">
              {SOUND_TOGGLES.map(t => (
                <Toggle key={t.key} testid={`toggle-sfx-${t.key}`} label={t.label} disabled={!soundOn}
                        checked={soundToggles[t.key]} onChange={(v) => updateSound(t.key, v)} />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Toggle({ label, checked, onChange, disabled, testid }) {
  return (
    <label className={`flex items-center justify-between gap-2 px-2 py-1 rounded ${disabled ? "opacity-40" : "hover:bg-slate-900/60"} cursor-pointer`}>
      <span className="text-slate-300">{label}</span>
      <button data-testid={testid} type="button" disabled={disabled} onClick={() => onChange(!checked)}
        className={`relative w-8 h-4 rounded-full transition-all ${checked ? "bg-blue-500" : "bg-slate-700"}`}>
        <span className={`absolute top-0.5 w-3 h-3 rounded-full bg-white transition-all ${checked ? "left-4" : "left-0.5"}`}/>
      </button>
    </label>
  );
}

export const DEFAULT_VISUAL_TOGGLES = {
  fvg: true, ifvg: true, swings: true, structure: true,
  sweeps: true, smt: true, pd: true, sessions: true,
};
export const DEFAULT_SOUND_TOGGLES = {
  FVG: true, IFVG: true, BOS: true, MSS: true,
  SWEEP_BSL: true, SWEEP_SSL: true, SMT: true, SESSION: true,
  PREMIUM: false, DISCOUNT: false, ORDER_FILL: true, PROFIT: true, LOSS: true,
};
